import React, { useState, useEffect } from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";
import api from "../../utils/api";

const COLORS = ["#0d6efd", "#6c757d", "#ffc107", "#198754", "#dc3545"];

const DeviceBreakdownChart = ({ queryParams }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get(`/api/analytics/devices?${queryParams}`)
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [queryParams]);

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border spinner-border-sm" role="status" />
      </div>
    );
  }

  if (!data) {
    return <p className="text-muted text-center">No data</p>;
  }

  const pieData = [
    { name: "Mobile", value: data.devices.mobile },
    { name: "Desktop", value: data.devices.desktop },
    { name: "Tablet", value: data.devices.tablet },
  ].filter((d) => d.value > 0);

  return (
    <div>
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            outerRadius={70}
            dataKey="value"
            label={({ name, percent }) =>
              `${name} ${(percent * 100).toFixed(0)}%`
            }
          >
            {pieData.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
      <h6 className="text-center mt-3 mb-2">Top Browsers</h6>
      <ResponsiveContainer width="100%" height={150}>
        <BarChart data={data.browsers.slice(0, 5)} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" width={70} tick={{ fontSize: 11 }} />
          <Tooltip />
          <Bar dataKey="count" fill="#6f42c1" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DeviceBreakdownChart;
